const skillGroups = [
  {
    name: "UX & Design",
    icons: [
      { iconPath: "images/figma_logo.svg", imgAlt: "Figma" },
      { iconPath: "images/affinity_logo.svg", imgAlt: "Affinity" },
      { iconPath: "images/inkscape_logo.svg", imgAlt: "Inkscape" },
    ],
  },
  {
    name: "Web Development",
    icons: [
      { iconPath: "images/react_logo.png", imgAlt: "React" },
      { iconPath: "images/redux_logo.svg", imgAlt: "Redux" },
      { iconPath: "images/javascript_logo.png", imgAlt: "JavaScript" },
      { iconPath: "images/typescript_logo.png", imgAlt: "TypeScript" },
      { iconPath: "images/nodejs_logo.svg", imgAlt: "Node.js" },
    ],
  },
  {
    name: "Testing",
    icons: [
      { iconPath: "images/gatling_logo.svg", imgAlt: "Gatling" },
      { iconPath: "images/playwright_logo.svg", imgAlt: "Playwright" },
      { iconPath: "images/cypress_logo.svg", imgAlt: "Cypress" },
    ],
  },
];

const Skills = () => {
  return (
    <div className="w-full max-w-full">
      <div
        id="skillsSection"
        className="
          w-full max-w-full
          flex flex-col md:flex-row
          items-stretch md:items-start
          gap-4 md:gap-8
          md:flex-wrap md:overflow-x-visible
          overflow-y-hidden
          pb-2
          [scrollbar-gutter:stable]
        "
      >
        {skillGroups.map((skill) => (
          <div
            key={skill.name}
            className="
              relative z-40 
              shadow-[0_4px_4px_rgba(0,0,0,0.25)]
              rounded-3xl
              mt-4 
              transition-[transform,width] duration-500 ease-in-out
              w-fit md:w-auto
              shrink-0
              md:min-w-[12rem] 
            "
          >
            <div className="relative bg-windowContent rounded-[1.5rem] p-6 md:p-8 pt-12 md:pt-16 h-full w-fit md:w-full">
              <div className="bg-windowBar rounded-t-[1.5rem] h-8 md:h-10 w-full absolute top-0 left-0 flex items-center px-4">
                <div className="rounded-full bg-icons-close h-2 w-2 mr-1" />
                <div className="rounded-full bg-icons-minimize h-2 w-2 mr-1" />
                <div className="rounded-full bg-icons-maximize h-2 w-2 mr-1" />
              </div>

              <span className="text-left uppercase font-bold block">
                {skill.name}
              </span>

              <div
                className="
                  mt-2
                  flex flex-wrap gap-3
                  overflow-x-auto
                  pb-1
                "
              >
                {skill.icons.map((item) => (
                  <img
                    key={item.imgAlt}
                    className="h-8 md:h-16 rounded-md md:rounded-xl"
                    src={item.iconPath}
                    alt={item.imgAlt}
                    title={item.imgAlt}
                    loading="lazy"
                    draggable={false}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
